module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av554-841b7ddc70dfe4c10a33d680fa46e654.jpg";